import * as React from "react";
import { getThemeColorVar } from "../helper/color";
import { css, cx } from "emotion";
const tabsBarClass = css({
    listStyle: "none",
    paddingLeft: 0,
    paddingBottom: 0,
    marginBottom: 0,
    backgroundColor: "transparent",
    whiteSpace: "nowrap",
    maxWidth: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    "> li": {
        display: "inline-block",
        "> a": {
            display: "block",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
            height: "30px",
            lineHeight: "30px",
            paddingLeft: "15px",
            paddingRight: "15px",
            userSelect: "none",
            "&:hover": {
                textDecoration: "none",
            },
        },
        "> a.inactive": {
            color: getThemeColorVar("primary", "default"),
        },
        "> a.active": {
            color: getThemeColorVar("primary", "default"),
        },
    },
});
const tabsBarSmallClass = css({
    "> li": {
        "> a": {
            textTransform: "none",
            fontSize: "14px",
            height: "48px",
            lineHeight: "48px",
        },
        "> a.inactive": {
            color: getThemeColorVar("typo", "default"),
        },
        "> a.active": {
            color: getThemeColorVar("primary", "default"),
        },
    },
});
const justifiedClass = css({
    display: "table",
    width: "100%",
    tableLayout: "fixed",
    "> li": {
        display: "table-cell",
        "> a:": {
            textAlign: "center",
            paddingLeft: "0px",
            paddingRight: "0px",
        },
    },
});
const isActiveClass = css({
    borderBottom: `2px solid ${getThemeColorVar("primary", "default")}`,
    "> a": {
        color: getThemeColorVar("primary", "default"),
    },
});
export const TabBar = (props) => {
    const { tabItems, selectedIndex, justified, small } = props;
    const classes = [tabsBarClass];
    justified && classes.push(justifiedClass);
    small && classes.push(tabsBarSmallClass);
    return (React.createElement("ul", { className: cx(classes) }, tabItems.map((tabItem, idx) => (React.createElement("li", { key: idx, className: cx(idx === selectedIndex ? [isActiveClass] : []) },
        React.createElement("a", { onClick: tabItem.onClick, className: idx === selectedIndex ? "active" : "inactive" }, tabItem.label))))));
};
export default TabBar;
//# sourceMappingURL=tabbar.js.map